import baseUrl from "../config/baseUrl";

const deleteCategory = async ({ token, id }) => {
  const formData = new FormData();
  formData.append("category_id", id);
  try {
    const response = await fetch(`${baseUrl}/apireact/delete_category`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteCategory;
